import {actionsFactory, props} from "@ngneat/effects";

const auth = actionsFactory('auth');
export const authLoginAction = auth.create('goToLoginAction');
export const authLogoutDoneAction = auth.create('logoutDoneAction');
